import { FC, memo } from 'react';
import { Badge } from 'antd';
import { PresetColorKey } from 'antd/es/theme/internal';
import { SelectOptions } from 'shared/types';

interface BadgedLabelProps {
  value: string;
  statusColorMap: Record<string, PresetColorKey>;
  selectOptions?: SelectOptions;
  ariaLabel?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const BadgedLabel: FC<BadgedLabelProps> = memo(({
  statusColorMap,
  value,
  selectOptions,
  ariaLabel,
  className,
  style,
}) => (
  <div
    style={{
      display: 'flex', alignItems: 'center', gap: '8px', ...style,
    }}
    className={className}
    role="status"
    aria-label={ariaLabel}
  >
    {statusColorMap[value] && <Badge color={statusColorMap[value]} />}
    <span>{selectOptions ? (selectOptions[value]) : value}</span>
  </div>
));

BadgedLabel.displayName = 'BadgedLabel';
